import type { BreadcrumbItem } from '../types/breadcrumb'
import { formatLibraryFolderSegment } from './dateDisplay'

/** 图库顶栏面包屑：完整路径；展示层按宽度规则折叠（见 ResponsiveBreadcrumbNav） */
export function buildLibraryPageBreadcrumbs(
  selectedFolderPath: string,
  onNavigateFolder?: (path: string) => void,
): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [
    { label: '首页', to: '/' },
    { label: '图库', onNavigate: onNavigateFolder ? () => onNavigateFolder('') : undefined, title: '图库根目录' },
  ]

  const segments = selectedFolderPath.split('/').filter(Boolean)
  if (segments.length === 0) {
    return items
  }

  for (let i = 0; i < segments.length; i++) {
    const path = segments.slice(0, i + 1).join('/')
    const parentPath = i === 0 ? '' : segments.slice(0, i).join('/')
    const label = formatLibraryFolderSegment(segments[i]!, parentPath)
    const isLast = i === segments.length - 1
    items.push({
      label,
      title: path,
      onNavigate: !isLast && onNavigateFolder ? () => onNavigateFolder(path) : undefined,
    })
  }

  return items
}
